export enum MenuItem {
    Pods,
    Profile,
    Yativerse,
    Invite,
    GlobalSearch,
}
export enum ActionItem {
    CreateYat,
    Wallet,
    InviteToYat,
}

export type NavigationArgs = number;

export interface MainNavigationProps {
    /** The active item will be highlighted. */
    activeItem?: MenuItem;
    /** Called whenever a menu item is clicked. */
    onSelectMenuItem: (item: MenuItem, args?: NavigationArgs) => void;
    /** Called whenever a menu item is clicked. */
    onSelectActionItem: (item: ActionItem, args?: NavigationArgs) => void;
    /** Pass the button title. Passed as prop so it can be i18n'd. */
    createYatsButtonText: string;
    /** Add red dot to profile button */
    notifyDotProfile: boolean;
    /** Use an absolute position on the liquid Id, even when `showTNY` is true */
    absolutePositionedLiquidId?: boolean;
    /** force disable LiquidId */
    disableLiquidId?: boolean;
}
